module.exports = __webpack_public_path__ + "img/imgshuai4_1.672915ce.png";